import { useOutletContext } from 'react-router';

import type { Space } from './entities';

/**
 * What `Core` hands to its child routes.
 *
 * `isSpaceLocked` is Core's local state, derived from how long the space's
 * subscription has been past due, so child routes cannot compute it themselves
 * and it is not worth lifting into a store for three consumers.
 */
export type SpaceOutletContext = {
  space: Space;
  isSpaceLocked: boolean;
};

export const useSpaceOutlet = (): SpaceOutletContext => useOutletContext<SpaceOutletContext>();
